import React from "react";
import AboutInfo from "../../../molecules/AboutInfo";
import ForgotPasswordCard from "../../../molecules/ForgotPasswordCard";
import MusicalAnimatedBackground from "../../../organisms/Background/MusicalAnimatedBackground/MusicalAnimatedBackground";
import "../LoginPage/index.css";

const ForgotPasswordPage = () => (
    <div className="login-page">
        <MusicalAnimatedBackground />
        <div className="login-container">
            <ForgotPasswordCard />
        </div>
        <AboutInfo />
    </div>
);

export default ForgotPasswordPage;
